<template>
  <div>
    <div>Custom Form Tenant Admin Role</div>
    <DxForm
      :form-data="formData"
      :items="items"
      :label-location="labelLocation">
     
    </DxForm>
  </div>
</template>

<script>
import { DxForm } from "devextreme-vue/form";

import DropDataGrid from "../components/DropDataGrid.vue";
import DxTextArea from "devextreme-vue/text-area";
import DxTextBox from "devextreme-vue/text-box";
import RelateTemp from "@/Layouts/RelateFieldTemplate.vue";
import LineItem from "@/components/LineItemCompo.vue";
import CheckboxGroup from "@/components/CstmCheckboxGroup.vue";
import { getQuickCreateDef } from "@include/utils/GridUtils.js";

export default {
  props: {
    createDef: Array,
    routeDef: String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DxForm,
    DxTextBox,
    getQuickCreateDef,
    LineItem,
    DropDataGrid,
    CheckboxGroup,
  },
  data: function () {
    return {
      formData: this.modelData,
      labelLocation: "top",
      watchList: [],
      log: console.log,
      items: this.createDef,
      fields : ['name', 'age'],
     
    };
  },
  watch: {
    
  },
  methods: {
    
  },
  mounted() {  },
};
</script>

<style>
.dx-form .dx-field-item-label {
  font-size: 12px;
  margin-bottom: 0px;
}
</style>